import { makeStyles } from "@material-ui/core";
import { color } from "../../../../assets/const/color";

export const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiCheckbox-colorPrimary.Mui-checked": {
      color: `${color.gray} !important`,
      borderRadius: "50px !important",
    },
    "& .MuiCheckbox-root.MuiCheckbox-indeterminate": {
      color: `${color.gray} !important`,
    },
    "& .MuiTableHead-root": {
      background: "#FEB62C",
      "& .MuiTableCell-root": {
        color: `${color.white} !important`,
        fontFamily: "inter",
      },
      "& :first-child": {
        borderRadius: "10px 0px 0px 0px !important",
      },
      "& :last-child": {
        borderRadius: "0px 10px 0px 0px !important",
      },
    },
    "& .MuiTableRow-root .MuiTableCell-root": {
      fontFamily: "inter !important",
    },
  },
  add_course_text: {
    fontFamily: "inter !important",
    fontSize: "18px !important",
    fontWeight: "700 !important",
    color: "#00473E",
  },
  label: {
    color: "#374151",
    fontFamily: "inter !important",
    fontSize: "14px !important",
    fontWeight: "500 !important",
  },
  form_add_course: {
    "& .MuiInputBase-root": {
      borderRadius: "50px",
      fontFamily: "inter !important",
    },
    "& .MuiButton-root:hover": {
      background: `${color.lightGreen} !important`,
      color: `${color.white} !important`,
    },
  },
  add_arrival: {
    width: "150px",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
  },
  greenBtn: {
    minWidth: "200px !important",
    textTransform: "capitalize !important",
    fontFamily: "inter !important",
    fontWeight: "700 !important",
    color: `${color.white} !important`,
    background: `${color.lightGreen} !important`,
    borderRadius: "23px !important",
  },
  form_container: {
    width: "40%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.between(960, 1320)]: {
      width: "60%",
    },
  },
  error: {
    color: "red",
    fontSize: "12px",
  },
  inputError: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgb(255 0 0 / 48%)",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
    "& .MuiOutlinedInput-root:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgb(255 0 0 / 48%) !important",
      },
    },
  },
}));
